var classes = {"videoCardContainer":"Byn8S","videoCardContentContainer":"i1Ljo","videoCardOverlay":"R10BF"};

export { classes as default };
